import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=600795c5&scoped=true&lang=css"
import "./assets/iosevka-etoile.css?vue&type=style&index=1&lang=css"
import "./App.vue?vue&type=style&index=2&id=600795c5&lang=css"

import exportComponent from "/home/alan-liang/Code/misc/GGJ22/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600795c5"]])

export default __exports__